/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:25 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/

import {RandomValues} from '../utils/random-values.utils' ;
import {ParserValues} from '../utils/parser-values.utils' ;

/**
 * No description for the module
 */
export class MyComplexObject 
{
    /**
	 * Public constructor
	 */
	constructor(public myId: number, public myName: string)
	{
			this.myId = myId ;
			this.myName = myName ;
	}
	
	/**
	 * @param myId the myId to set
	 */
	setMyId(myId)
	{
		this.myId = myId ;
	}
	
	/**
	 * @return the myId
	 */
	getMyId()
	{
		return this.myId ;
	}
		
	/**
	 * @param myName the myName to set
	 */
	setMyName(myName)
	{
		this.myName = myName ;
	}
	
	/**
	 * @return the myName
	 */
	getMyName()
	{
		return this.myName ;
	}
		

	/**
	 * @return the object as string
	 */
	toString()
	{
		return JSON.stringify(this, null, 4) ;
	}
	
	/**
	 * @param pendingRecursiveCalls with the pending recursive calls
	 * @return a new instance of the class with a random values
	 */
	static generateRandomInstance(pendingRecursiveCalls: number)
	{
		if (pendingRecursiveCalls == 0)
		{
			return null ;
		}
		
		pendingRecursiveCalls -- ;

		var myId = RandomValues.generateRandomNumber() ;
		var myName = RandomValues.generateRandomString() ;

		return new MyComplexObject(myId, myName) ;
	}
	
	/**
	 * @param internalValueParseGenerator with the json to be parsed
	 * @return an instance of this class
	 */	
	static parse(internalValueParseGenerator)
	{
		var myId ;
		if (internalValueParseGenerator.myId != null && internalValueParseGenerator.myId != "undefined")
		{
			myId = ParserValues.numberParser(internalValueParseGenerator.myId) ;
		}
		
		var myName ;
		if (internalValueParseGenerator.myName != null && internalValueParseGenerator.myName != "undefined")
		{
			myName = ParserValues.stringParser(internalValueParseGenerator.myName) ;
		}
		

		return new MyComplexObject(myId, myName) ;	
	}
};
